export default __webpack_public_path__ + "static/media/scissors.0c9990d9.png";